<template>
  <div>
    <div class="banner"></div>
    <div class="bgb">
      <div class="wid600 ym_form">
        <form>
          <div class="kc-li">
            <b>疫苗名称</b><input v-model="$store.state.name" @focus="select('SelectVaccine')" placeholder="请选择（必选）" type="text"></div>
          <div class="kc-li">
            <b>生产厂家</b><input v-model="$store.state.producer" ref="selepro" @focus="select('SelectProducer')" placeholder="请选择（必选）" type="text"></div>
          <div class="kc-li">
            <b>疫苗批号</b><input v-model="$store.state.no" placeholder="例如20140301-1或 K2164-1" style="background: none;" type="text"></div>
          <div class="tips">
            <a href="javascript:;" @click="$router.push({ name: 'Guide' });">如何查看疫苗批号</a>
          </div>
          <input class="submit-btn" type="button" @click="check" value="查询疫苗">
        </form>
      </div>
    </div>
    <div class="wid600">
      <div class="laiyuan">
        <p>数据来源：中国食品药品检定研究院</p>
        <p>若有疑问可咨询当地疾控中心或接种单位</p>
      </div>
      <div class="bottominfo">
        <a href="#"><img src="https://image.39.net/index/images/logo.png"></a>
        <p>由39健康网技术提供</p>
      </div>
    </div>
  </div>
</template>

<script>
import ynav from "../components/nav";
import * as api from "../libs/api";

export default {
	components: {
		ynav
	},
	data() {
		return {};
	},
	methods: {
		select(routerName) {
			if (routerName) {
				if (routerName == "SelectProducer" && !this.$store.state.name) {
					this.$refs.selepro.blur();
					alert("请先选择疫苗名称");
					return;
				}
				this.$router.push({ name: routerName });
			}
		},
		check() {
			var data = {
				name: this.$store.state.name,
				company: this.$store.state.producer,
				codename: this.$store.state.no
			};

			if (!data.name) {
				alert("请选择疫苗名称");
				return;
			}
			if (!data.company) {
				alert("请选择生产厂家");
				return;
			}
			if (!data.codename) {
				alert("请填写疫苗批号");
				return;
			}

			this.$store.commit("pushNo", data.codename);
			api.checking(data).then(res => {
				if (res.status == 200 && res.data.status == "Ok") {
					let result = res.data.results.List;
					if (result && result.length > 0) {
						this.$store.commit("pushResult", result[0]);
						this.$router.push({ name: "Result", params: { id: result[0]["IsRecall"] ? "danger" : "clear" } });
					} else {
						this.$router.push({ name: "Result", params: { id: "noresult" } });
					}
				} else {
					alert("加载数据异常~");
				}
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/views/Index.vue